// extracted by mini-css-extract-plugin
module.exports = {"container":"cC","imgContainer":"dC","content":"eC","brand":"fC","product":"gC","price":"hC","noLink":"iC"};